module.exports = __webpack_public_path__ + "static/img/realize_pagamento.1811d53.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/icons/realize_pagamento.jpg
// module id = SfZN
// module chunks = 1